import _ from 'lodash';
import { getMagicLinkPatientProfileData } from './endpoints/userWeb';

export const ApiRoutes = {
  Login: {
    GetUserSession: '/Login/GetUserSession',
    ValidateActivationCode: '/Login/ValidateActivationCode',
    SendActivationCode: '/Login/SendActivationCode',
    LoginPost: '/Login/Login',
    LoginWithExistingPost: '/Login/LoginWithExisting',
    LogOutPost: '/Login/Logout',
    GetMedStratSigningUrl: '/Login/MedStratSigningUrl',
    GetListOfCountries: '/Login/GetSupportedCountriesList',
    GetForgottenUserName: '/Login/GetForgottenUsername',
    GetClientStyleCss: '/Login/GetClientStyleCSS',
    GetCustomerSupportInfo: '/Login/GetCustomerSupportInfo',
    GetHasPasscode: '/Login/GetHasPasscode'
  },

  GetLocalizedStrings: '/Localization/GetLocalizedStrings',

  GetSettings: '',
  Settings: {
    PreBootSettings: '/Settings/PreBootSettings',
    GetBestFitCultureProvider: '/Settings/GetBestFitCultureProvider',
    GetInstructionsForUseUrl: '/Settings/GetInstructionsForUseUrl',
    GetSupportInfo: '/Settings/GetSupportInfo',
  },

  Message: {
    GetMessages: '/Message/GetMessages',
    SendMessage: '/Message/SendMessage',
    MarkAllMessagesAsRead: '/Message/MarkAllMessagesAsRead',
    GetCareTeam: '/Message/GetCareTeam',
    SendMAFeedback: '/Message/MessageAssistFeedback',
    GetEdItemFromURL: '/Asset/GetEdItemFromURL',
    },

  Procedure: {
    SetConfirmedSurgeryDate: '/Procedure/SetConfirmedSurgeryDate',
    SetSelectedProcedure: '/Procedure/SetSelectedProcedure',
    GetPatientProcedures: '/Procedure/GetPatientProcedures',
    DismissInterrupt: '/Procedure/DismissInterrupt'
  },

  Patient: {
    GetPatientProfileData: '/Patient/GetPatientProfileData',
    GetMagicLinkPatientProfileData: '/Patient/GetMagicLinkPatientProfileData',
    LinkCanaryAccount: '/Patient/LinkCanaryAccount',
    Alerts: '/Patient/GetAlerts',
    Tasks: '/Patient/GetTasks',
    ChangePassword: '/Patient/ChangePassword',
    GetPatientConfigAsync: '/Patient/GetPatientConfig',
    PIQSetup: {
      CanaryAddress: '/Patient/CanaryMailingAddress',
      CanaryHeightWeight: '/Patient/CanaryHeightWeight',
      CanarySampleTimezone: '/Patient/CanarySampleTimezone',
      CanaryCaregiverDetail: '/Patient/CanaryCaregiverDetail',
      NextCanaryPatientActivationStep: '/Patient/NextCanaryPatientActivationStep',
      CanaryCompleteBaseStationSetup: '/Patient/CanaryCompleteBaseStationSetup',
      UpdateCanaryMeetComputerRequirements: '/Patient/UpdateCanaryMeetComputerRequirements',
      Dismisscanaryactivation: '/Patient/DismissCanaryActivation',
      UpdateHBSVersion: '/Patient/UpdateHBSVersion',
    },
    SetProcedureConsent: '/Patient/SetProcedureConsent',
    GetCommunicationPreferences: '/Patient/GetCommunicationPreferences',
    SetCommunicationPreferences: '/Patient/SetCommunicationPreferences',
    SmsOptOut: '/Patient/SmsOptOut',
    Hydrate: '/Patient/Hydrate'
  },

  Statistics: {
    GetEocSummaries: '/Statistics/GetEocSummaries',
    GetEocSummaryDetails: '/Statistics/GetEocSummaryDetails',
    PatientDataSources: '/Statistics/PatientDataSources',
    PatientMeasurementStats: '/Statistics/PatientMeasurementStats',
    PatientProgress: '/Statistics/PatientProgress',
    PatientStatisticSummaries: '/Statistics/GetPatientStatisticSummaries',
  },

  Calendar: {
    GetSurveyDefinition: '/Calendar/GetSurveyDefinition',
    GetEducationAsset: '/Calendar/GetEducationAsset',
    GetRosaVideoAsset: '/Calendar/GetRosaVideoAsset',
    UpdateSurveyProgress: '/Calendar/UpdateSurveyProgress',
    UpdateEducationStatus: '/Calendar/UpdateEducationStatus',
    GetLibraryEdItems: '/Patient/GetEducationLibraryItems',
    GetLibraryRosaItems: '/Calendar/GetRosaLibraryItems'
  },

  Routine: {
    GetRoutine: '/Routine/GetRoutine',
    UpdateExerciseCompletion: '/Routine/UpdateExerciseCompletion',
    SetRoutineCompleteRequest: '/Routine/SetRoutineComplete'
  },

  Registration: {
    ValidatePassword: '/Registration/ValidatePassword',
    CreatePassword: '/Registration/CreatePassword',
    SetPassword: '/Registration/SetPassword',
    PutProfileInformation: '/Registration/ProfileInformation',
    UserName: '/Registration/UserName',
    GetLocalizedUserPolicy: '/Registration/GetLocalizedUserPolicy',
    UpdatePolicy: '/Registration/UpdateUserPolicySignOff',
    UploadProfilePhoto: '/Registration/UploadProfilePhoto',
    GetRegistrationNextStep: '/Registration/GetNextRegistrationStep',
    GetNextRegistrationStepSkipLoginWithExisting: '/Registration/GetNextRegistrationStepSkipLoginWithExisting'
  }
}

export function mapAPIRoutes() {
  const proxy: any = {};

  _.each(ApiRoutes, function (route) {
    if (typeof route === 'object') {
      layer(route);
    }
    if (typeof route === 'string' && !_.isEmpty(route)) {
      addNode(route);
    }
  });

  function layer(object: any) {
    _.each(object, function (route) {
      if (typeof route === 'string') {
        addNode(route);
      } else {
        layer(route);
      }
    })
  }

  function addNode(route: string) {
    proxy[route] = {
      target: 'https://localhost:45441',
      changeOrigin: true,
      secure: false,
    };
  }
  return proxy;
}
